import { toJS, action, reaction, computed, observable } from 'mobx';

export default class UserSettings {
  @observable eventView = new Map();
  @observable allGuestsView = new Map();

  constructor() {
    const userSettingsFromStorage = JSON.parse(window.localStorage.getItem('tk-glm-userSettings'));
    if (userSettingsFromStorage) {
      if (userSettingsFromStorage.allGuestsView) {
        this.allGuestsView = Object.keys(userSettingsFromStorage.allGuestsView).reduce(
          (map, key) => map.set(key, userSettingsFromStorage.allGuestsView[key]),
          new Map()
        );
      }
      if (userSettingsFromStorage.eventView) {
        this.eventView = Object.keys(userSettingsFromStorage.eventView).reduce(
          (map, key) => map.set(key, userSettingsFromStorage.eventView[key]),
          new Map()
        );
      }
    }
    this.saveUponChange();
  }

  saveUponChange() {
    reaction(
      () => this.serializedUserSettings,
      () => {
        this.save();
      },
      { delay: 1000 }
    );
  }

  save() {
    localStorage.setItem('tk-glm-userSettings', this.serializedUserSettings);
    return true;
  }

  @computed
  get serializedUserSettings() {
    return JSON.stringify({
      eventView: toJS(this.eventView),
      allGuestsView: toJS(this.allGuestsView),
    });
  }

  isColumnVisible(isAllGuestsView, eventId, columnName) {
    return isAllGuestsView
      ? this.isColumnVisibleInAllGuestsView(columnName)
      : this.isColumnVisibleInEventView(eventId, columnName);
  }

  isEventColumnVisible(eventId) {
    return this.isEventColumnVisibleInAllGuestsView(eventId);
  }

  @action
  toggleColumnVisibility(isAllGuestsView, eventId, columnName) {
    if (isAllGuestsView) {
      this.toggleColumnVisibilityInAllGuestsView(columnName);
    } else {
      this.toggleColumnVisibilityInEventView(eventId, columnName);
    }
  }

  @action
  toggleEventColumnVisibility(eventId) {
    this.toggleEventColumnVisibilityInAllGuestsView(eventId);
  }

  // private

  isColumnVisibleInEventView(eventId, columnName) {
    const event = this.eventView.get(eventId);
    return event && event.hiddenColumns ? !event.hiddenColumns.includes(columnName) : true;
  }

  isColumnVisibleInAllGuestsView(columnName) {
    const hiddenColumns = this.allGuestsView.get('hiddenColumns');
    return hiddenColumns ? !hiddenColumns.includes(columnName) : true;
  }

  isEventColumnVisibleInAllGuestsView(eventId) {
    const event = this.eventView.get(eventId);
    return event ? !event.hiddenOnDashboard : true;
  }

  @action
  toggleColumnVisibilityInEventView(eventId, columnName) {
    const event = this.eventView.get(eventId);
    if (event) {
      if (event.hiddenColumns.includes(columnName)) {
        event.hiddenColumns.remove(columnName);
      } else {
        event.hiddenColumns.push(columnName);
      }
    } else {
      this.eventView.set(eventId, { hiddenColumns: [columnName], hiddenOnDashboard: false });
    }
  }

  @action
  toggleColumnVisibilityInAllGuestsView(columnName) {
    const hiddenColumns = this.allGuestsView.get('hiddenColumns');
    if (hiddenColumns) {
      if (hiddenColumns.includes(columnName)) {
        hiddenColumns.remove(columnName);
      } else {
        hiddenColumns.push(columnName);
      }
    } else {
      this.allGuestsView.set('hiddenColumns', [columnName]);
    }
  }

  @action
  toggleEventColumnVisibilityInAllGuestsView(eventId) {
    const event = this.eventView.get(eventId);
    if (event) {
      event.hiddenOnDashboard = !event.hiddenOnDashboard;
    } else {
      this.eventView.set(eventId, { hiddenColumns: [], hiddenOnDashboard: true });
    }
  }
}
